export default {
  "nav-item": "_nav-item_1nt6ug body-1",
  "active": "_active_1nt6ug"
};